import { Text, View, type ImageStyle } from "react-native";
import { Image } from "expo-image";
import { resolveStorageUrl } from "@lezz/supabase";

type AvatarProps = {
  url?: string | null;
  name?: string | null;
  size: number;
  borderWidth?: number;
  borderColor?: string;
  style?: ImageStyle;
};

export function Avatar({
  url,
  name,
  size,
  borderWidth,
  borderColor,
  style,
}: AvatarProps) {
  const borderRadius = size / 2;
  const initial = (name?.[0] || "?").toUpperCase();
  const fontSize = size * 0.3;

  const baseStyle: ImageStyle = {
    width: size,
    height: size,
    borderRadius,
    ...(borderWidth ? { borderWidth, borderColor } : {}),
  };

  if (url) {
    return (
      <Image
        source={{ uri: resolveStorageUrl(url) }}
        contentFit="cover"
        style={[baseStyle, style]}
        accessibilityLabel={name ? `${name}'s avatar` : "Avatar"}
      />
    );
  }

  return (
    <View
      className="bg-brand items-center justify-center"
      style={[baseStyle, style]}
      accessibilityElementsHidden={true}
    >
      <Text className="text-brand-foreground font-bold" style={{ fontSize }}>
        {initial}
      </Text>
    </View>
  );
}
